import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from '../../../services/navigation-service';
import {
  PATH_NEGOCIOS, PATH_PIZARRA, PATH_PRECIOS, PATH_FINANCIERA, PATH_PIPELINE, PATH_DASHBOARD
} from '../../../navigation/navigation.module';
import { ColaboradoresService } from '../../../services/colaboradores-service';
import { NegociosComponent } from '../negocios/negocios.component';
import { PermisosService, NEG_ACTIONS, PERM_ACCIONES_ID } from '../../../services/permisos-service';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';
import {NegocioListComponent} from '../negocios';

@Component({
  selector: 'app-negocios-header',
  templateUrl: './negocios-header.component.html',
  styleUrls: ['./negocios-header.component.scss']
})
export class NegociosHeaderComponent implements OnInit {

  @ViewChild(NegociosComponent) negocioComp;

  selectedTabIndex: number = 0;

  NEG_ACTIONS = NEG_ACTIONS;
  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  @ViewChild(NegocioListComponent) private tabNegocio: NegocioListComponent;

  private self: NegociosHeaderComponent = this;

  private crearNegocioAllowed = false;

  negocioTabs = [PATH_NEGOCIOS,/* PATH_PIPELINE,*/ PATH_DASHBOARD];

  tabsLoaded = [false, /*false,*/ false];


    constructor(private router: Router,
              private navigationService: NavigationService,
              private location: Location,
              private colaboradorService: ColaboradoresService,
              private permisosService: PermisosService,
              private firebaseService: FirebaseMessagingService,
  ) {
    this.permisosService.verificarAccesoDeURL();

    this.crearNegocioAllowed = this.permisosService.showNegocioAction(NEG_ACTIONS.CREAR);
  }

  ngOnInit() {

    /** Dado que esta seccion es la pagina por defecto, debemos ser capaces de lidiar con cualquier URL simplemente verificamos que
     * cualquier URL ingresada no es igual a la de negocios, asumimos que se viaja a la URL de negocios y luego la misma se aplica como la URL seteada
     * ¿Deberíamos crear una página específica con un mensaje de 404?**/

    if (/*this.router.url.substring(1) !== PATH_PIPELINE && */this.router.url.substring(1) !== PATH_DASHBOARD) {
      this.selectedTabIndex = 0;
    } else {
      this.selectedTabIndex = this.negocioTabs.indexOf(this.router.url.substring(1));
    }
    this.selectTab(this.selectedTabIndex);
  }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }

  selectTab(e) {
    this.location.go(this.negocioTabs[e]);
    // Analytics
    this.firebaseService.sendToAnalytics(this.negocioTabs[e]);
    this.tabsLoaded[e] = true;
  }

  showCreateNegocioButton() {
    if (this.tabNegocio) {
      const isTabNegocios = this.selectedTabIndex === 0;
      const noRowSelected = this.tabNegocio.selectedIndex < 0;
      return isTabNegocios && noRowSelected && this.crearNegocioAllowed;
    } else {
      return false;
    }
  }

  showNegocioButton(accion: string) {
    if (!this.tabNegocio) {
      return false;
    }
    const rowSelected = this.tabNegocio.selectedIndex >= 0;
    if (rowSelected) {
      return this.permisosService.showNegocioAction(accion, this.tabNegocio._rows[this.tabNegocio.selectedIndex].Confirmacion.Estado, this.tabNegocio._rows[this.tabNegocio.selectedIndex].TipoNegocio.Id);
    }
    return false;
  }

}





// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/header/negocios-header.component.ts